import { jsx as _jsx } from "react/jsx-runtime";
import { AccordionContext, defaultAccordionContext } from './accordion.context';
/**
 * A group of components that allow for the building of an accordion.
 *
 * The accordion can be `disabled` by providing that prop to the `<Accordion />` component. This will force the accordion into a fully expanded state without click events.
 *
 * Each `<AccordionItem>` can also take a prop of `open` to ensure that its content section is open by default.
 *
 * A prop of `disabled` can be passed to an`<AccordionItem>` to force the item into a fully expanded state and remove the chevron icon.
 */
export const Accordion = ({ children, as: Tag = 'div', disabled = false, darkTheme = false, ...rest }) => {
    const accordionContext = {
        ...defaultAccordionContext,
        disabled,
        darkTheme,
    };
    return (_jsx(AccordionContext.Provider, { value: accordionContext, children: _jsx(Tag, { ...rest, children: children }) }));
};
//# sourceMappingURL=accordion.js.map